import { render, staticRenderFns } from "./Descriptions.vue?vue&type=template&id=253f0c10&"
import script from "./Descriptions.vue?vue&type=script&lang=js&"
export * from "./Descriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports